export default __webpack_public_path__ + "static/media/two_conv_mppt_topology_reduced.89d9664a.png";